<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Product" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
  <ion-virtual-scroll [items]="productList | filterDetailLine: queryText">
    <ion-item *virtualItem="let p" (click)="setProduct(p)">
      <ion-label>
        <h4><strong>{{p.plu}}</strong></h4>
        <p>{{p.description}}</p>
      </ion-label>
    </ion-item>
  </ion-virtual-scroll>
</ion-content>
